(function () {
  function extractGrams(title) {
    var regex = /(\d+(?:[.,]\d+)?)\s*g(?![a-z])/gi, m;
    while ((m = regex.exec(title)) !== null) {
      var before = title.slice(0, m.index).match(/([a-zA-Z])\s*$/);
      if (before && before[1].toLowerCase() === 'm') continue;
      var v = parseFloat(m[1].replace(',', '.'));
      if (!isNaN(v)) return v;
    }
    return null;
  }

  function fmt(amount, currency) {
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency || 'EUR' }).format(amount);
    } catch(e) {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amount);
    }
  }

  function isDefaultTitle(t) {
    return (t || '').trim().toLowerCase() === 'default title';
  }

  function selectVariantInSense(options, container) {
    // Chercher variant-selects dans la même section que nos tuiles
    var section = container.closest('section') || document.body;
    var vs = section.querySelector('variant-selects');
    if (!vs) return;

    var selects = vs.querySelectorAll('select');
    if (selects.length > 0) {
      selects.forEach(function(sel, i) {
        if (options[i] !== undefined) {
          sel.value = options[i];
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      return;
    }

    var radios = vs.querySelectorAll('input[type="radio"]');
    if (radios.length > 0) {
      options.forEach(function(val) {
        var input = vs.querySelector('input[type="radio"][value="' + CSS.escape(val) + '"]');
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  }

  function initTiles() {
    var container = document.getElementById('variant-price-tiles');
    if (!container) return;

    var pid = container.dataset.productId;
    var primaryColor = container.dataset.primaryColor || '#429d8a';
    var badgeColor = container.dataset.badgeColor || '#febd59';
    var hideNative = container.dataset.hideNative === 'true';

    container.style.setProperty('--vpt-primary', primaryColor);
    container.style.setProperty('--vpt-badge', badgeColor);

    // Masquer uniquement le variant-selects dans la même section
    var section = container.closest('[data-section-id]') || container.closest('section') || document.body;


    function hideVariantSelects() {
      var vs = section.querySelector('variant-selects');
      if (vs && !vs.classList.contains('vpt-hidden')) {
        vs.classList.add('vpt-hidden');
      }
    }

    if (hideNative) {
      hideVariantSelects();
      var observer = new MutationObserver(hideVariantSelects);
      observer.observe(section, { childList: true, subtree: true });
    }

    var data = window['__variantData_' + pid];
    if (!data || !data.variants.length) return;

    var variants = data.variants;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

    var computed = variants.map(function(v) {
      var g = extractGrams(v.title);
      var ppg = (g && g > 0 && v.price > 0) ? v.price / g : null;
      return { v: v, g: g, ppg: ppg, disc: null };
    });

    var availableWithPpg = computed.filter(function(c) { return c.v.available && c.ppg !== null; });
    var refPPG = availableWithPpg.length > 0
      ? Math.max.apply(null, availableWithPpg.map(function(c) { return c.ppg; }))
      : null;

    computed.forEach(function(c) {
      if (c.ppg !== null && refPPG && c.ppg < refPPG) {
        c.disc = Math.round((1 - c.ppg / refPPG) * 100);
      }
    });

    var urlId = parseInt(new URLSearchParams(window.location.search).get('variant')) || variants[0].id;
    var selectedId = urlId;

    container.innerHTML = '';

    var familyMap = new Map();
    computed.forEach(function(c) {
      var key = c.v.options.length > 1 ? c.v.options[0] : null;
      if (!familyMap.has(key)) familyMap.set(key, []);
      familyMap.get(key).push(c);
    });

    familyMap.forEach(function(items, familyLabel) {
      var availableItems = items.filter(function(c) { return c.v.available; });
      if (availableItems.length === 0) return;

      var groupEl = document.createElement('div');
      groupEl.className = 'vpt-group';

      if (familyLabel && familyMap.size > 1) {
        var labelEl = document.createElement('div');
        labelEl.className = 'vpt-group-label';
        labelEl.textContent = familyLabel;
        groupEl.appendChild(labelEl);
      }

      var grid = document.createElement('div');
      grid.className = 'vpt-grid';

      availableItems.forEach(function(c) {
        var tile = document.createElement('div');
        tile.className = 'vpt-tile' + (c.v.id === selectedId ? ' is-selected' : '');
        tile.dataset.variantId = c.v.id;

        var weightLabel = c.v.options.length > 1 ? c.v.options[1] : c.v.title;

        var html = '';
        if (!isDefaultTitle(weightLabel)) {
          html += '<span class="vpt-tile__label">' + weightLabel + '</span>';
        }
        html += '<span class="vpt-tile__price">' + fmt(c.v.price, currency) + '</span>';
        if (c.ppg !== null) {
          html += '<span class="vpt-tile__ppg">' + fmt(c.ppg, currency) + '/g</span>';
        }
        if (c.disc !== null && c.disc > 0) {
          html += '<span class="vpt-tile__badge">-' + c.disc + '%</span>';
        }
        tile.innerHTML = html;

        tile.addEventListener('click', function() {
          container.querySelectorAll('.vpt-tile').forEach(function(t) {
            t.classList.remove('is-selected');
          });
          tile.classList.add('is-selected');
          selectedId = c.v.id;

          selectVariantInSense(c.v.options, container);

          var url = new URL(window.location.href);
          url.searchParams.set('variant', c.v.id);
          window.history.replaceState({}, '', url.toString());
        });

        grid.appendChild(tile);
      });

      groupEl.appendChild(grid);
      container.appendChild(groupEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTiles);
  } else {
    initTiles();
  }
})();
